const DEFAULT_TEACHER_RATES = Object.freeze(Object.fromEntries([
  [1, 80, 100], [2, 85, 110], [3, 90, 120], [4, 95, 130], [5, 100, 140], [6, 105, 150],
].map(([count, short, long]) => [count, Object.freeze({ 45: short, 60: long })])));
module.exports = { DEFAULT_TEACHER_RATES };
